import { Box, makeStyles, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";
import PreSaleIcon from "../icons/PreSaleIcon";
import alertaStyles from "./Alerta.styles";

dayjs.extend(utc);

const useStyles = makeStyles(() => ({
	...alertaStyles,
	alertBox: {
		...alertaStyles.alertBox,
		marginTop: "24px",
		marginBottom: "28px",
		justifyContent: "space-between",
		gap: "16px",
	},
	alertSubtitle: {
		...alertaStyles.alertSubtitle,
		fontWeight: 400,
	},
}));

const getAlertMessages = (formattedLaunchDate) => ({
	"<D-1": (
		<>
			Pedidos em pré-venda passam para <strong>Novo Pedido</strong> um dia
			antes do lançamento ({formattedLaunchDate}), só então serão liberados para movimentação.
		</>
	),
	"D-1": (
		<>
			É ideal separar este pedido hoje. E amanhã, {formattedLaunchDate},
			confirme o estoque e deixe tudo pronto para retirada.
		</>
	),
	"D0": (
		<>
			Dê prioridade à separação e retirada. Este pedido faz parte do lançamento de hoje.
		</>
	),
});

const AlertaPreVenda = ({ dataLancamento }) => {
	const classes = useStyles();

	if (!dataLancamento) {
		return null;
	}

	const today = dayjs().startOf("day");
	const launchDate = dayjs(dayjs.utc(dataLancamento).format("YYYY-MM-DD")).startOf("day");
	const diffInDays = launchDate.diff(today, "day");

	const scenarioKey = diffInDays > 1 ? "<D-1" : diffInDays === 1 ? "D-1" : "D0";

	const formattedLaunchDate = launchDate.format("DD/MM/YYYY");
	const subtitleContent = getAlertMessages(formattedLaunchDate)[scenarioKey];

	return (
		<Box className={classes.alertBox}>
			<PreSaleIcon size="small" />
			<Box display={"flex"} flexDirection={"column"} flex={1}>
				<Typography variant="inherit" className={classes.alertTitle}>
					Este é um pedido feito em pré-venda.
				</Typography>
				<Typography variant="caption" className={classes.alertSubtitle}>
					{subtitleContent}
				</Typography>
			</Box>
		</Box>
	);
};

export default AlertaPreVenda;
